import { Link } from "react-router-dom";
import { useAdminGetUserQuizStatsQuery } from "../../../services/organization/adminUsers";
import ExamProgressCard from "../../cards/Exam/ExamProgressCard";
import LoadingIndicator from "../../LoadingIndicator";
import { useTranslation } from "react-i18next";

const Exams = ({ user }) => {
  const { data: quizStats, isLoading: isGetUserQuizStatsLoading } =
    useAdminGetUserQuizStatsQuery(user?.id);

  const { t } = useTranslation(["common"]);

  if (isGetUserQuizStatsLoading) return <LoadingIndicator />;

  const visibleExams =
    quizStats?.data?.filter((exam) => exam?.lesson_log?.answers?.length) ?? [];

  return (
    <div className="profile-about">
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          {visibleExams.length ? (
            visibleExams.map((exam) => (
              <Link
                key={exam?.lesson_log?.id}
                to={`/admin/${user?.id}/exams/${exam?.lesson_log?.id}`}
              >
                <ExamProgressCard exam={exam} className="mb-4" />
              </Link>
            ))
          ) : (
            <p className="admin-employee-profile__empty-state">
              {t("noExamsYet")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Exams;
